(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-media-gallery-left"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('media-gallery-left')) {
    customElements.define(
      'media-gallery-left',
      class MediaGalleryLeft extends HTMLElement {
        constructor() {
          super();
          this.sectionId = this.dataset.sectionId;
          this.currentIndex = 0;
          this.thumbnails = [];
          this.slides = [];
          this.init();
        }

        init() {
          const thumbnailsContainer = this.querySelector('#ThumbnailsContainer-' + this.sectionId);
          const mainContainer = this.querySelector('#MainContainer-' + this.sectionId);
          
          if (!thumbnailsContainer || !mainContainer) return;

          this.thumbnails = Array.from(thumbnailsContainer.querySelectorAll('.product-gallery-left__thumbnail'));
          this.slides = Array.from(mainContainer.querySelectorAll('.product-gallery-left__slide'));

          if (this.thumbnails.length === 0 || this.slides.length === 0) return;

          this.slides.forEach((slide, index) => {
            slide.setAttribute('data-slide-index', index);
          });

          this.prevButton = this.querySelector('.product-gallery-left__nav-button--prev');
          this.nextButton = this.querySelector('.product-gallery-left__nav-button--next');

          this.thumbnails.forEach((thumbnail, index) => {
            thumbnail.addEventListener('click', () => this.goToSlide(index));
          });

          if (this.prevButton) {
            this.prevButton.addEventListener('click', () => this.previousSlide());
          }

          if (this.nextButton) {
            this.nextButton.addEventListener('click', () => this.nextSlide());
          }

          this.currentIndex = 0;
          
          this.slides.forEach((slide, index) => {
            if (index === 0) {
              slide.classList.add('is-active');
            } else {
              slide.classList.remove('is-active');
            }
          });
          
          this.thumbnails.forEach((thumbnail, index) => {
            if (index === 0) {
              thumbnail.classList.add('is-active');
              thumbnail.setAttribute('aria-current', 'true');
            } else {
              thumbnail.classList.remove('is-active');
              thumbnail.setAttribute('aria-current', 'false');
            }
          });
          
          this.updateButtons();
          
          setTimeout(() => {
            if (this.slides[this.currentIndex]) {
              this.updateSlides();
              this.playActiveMedia(this.slides[this.currentIndex]);
            }
          }, 150);
        }

        goToSlide(index) {
          if (index < 0 || index >= this.slides.length || index === this.currentIndex) return;

          const previousIndex = this.currentIndex;
          this.currentIndex = index;
          
          this.updateSlides();
          this.updateThumbnails();
          this.updateButtons();
          
          setTimeout(() => {
            this.playActiveMedia(this.slides[this.currentIndex]);
          }, 300);
          
          this.scrollThumbnailIntoView();
        }

        previousSlide() {
          if (this.currentIndex > 0) {
            this.goToSlide(this.currentIndex - 1);
          }
        }

        nextSlide() {
          if (this.currentIndex < this.slides.length - 1) {
            this.goToSlide(this.currentIndex + 1);
          }
        }

        updateSlides() {
          this.slides.forEach((slide, index) => {
            if (index === this.currentIndex) {
              slide.classList.add('is-active');
            } else {
              slide.classList.remove('is-active');
            }
          });
        }

        updateThumbnails() {
          this.thumbnails.forEach((thumbnail, index) => {
            thumbnail.classList.toggle('is-active', index === this.currentIndex);
            thumbnail.setAttribute('aria-current', index === this.currentIndex ? 'true' : 'false');
          });
        }

        updateButtons() {
          if (this.prevButton) {
            this.prevButton.disabled = this.currentIndex === 0;
          }
          if (this.nextButton) {
            this.nextButton.disabled = this.currentIndex === this.slides.length - 1;
          }
        }

        scrollThumbnailIntoView() {
          const activeThumbnail = this.thumbnails[this.currentIndex];
          if (!activeThumbnail) return;

          const isMobile = window.matchMedia('(max-width: 749px)').matches;
          
          if (isMobile) {
            activeThumbnail.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
          } else {
            activeThumbnail.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
          }
        }

        playActiveMedia(activeSlide) {
          if (typeof window.pauseAllMedia === 'function') {
            window.pauseAllMedia();
          }
          const deferredMedia = activeSlide.querySelector('.deferred-media');
          if (deferredMedia && typeof deferredMedia.loadContent === 'function') {
            deferredMedia.loadContent(false);
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
